import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import ListingCard from '../../components/ListingCard/ListingCard';
import css from './ListingPage.module.css';

const cardRenderSizes = () =>
  '(max-width: 550px) 100vw, (max-width: 768px) 50vw, (max-width: 1024px) 33vw, 300px';

const SimilarListings = ({ similarListings, intl }) => {
  if (!Array.isArray(similarListings) || similarListings.length === 0) return null;
  return (
    <div className={css.nearbyListingsSection}>
      <h2 className={css.sectionHeading}>
        <FormattedMessage id="ListingPage.nearbyListingsHeading" />
      </h2>
      <div className={css.nearbyListingsGrid}>
        {similarListings.map(l => {
          if (!l || !l.id) return null;
          return (
            <ListingCard
              className={css.listingCard}
              key={l.id.uuid}
              listing={l}
              renderSizes={cardRenderSizes(false)}
              setActiveListing={() => { }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default SimilarListings;